import faker from 'faker';
import { sum } from 'lodash';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  Stack,
  Button,
  TextField,
  OutlinedInput,
  Tooltip
} from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { fCurrency } from 'src/utils/formatNumber';
import Page from 'src/components/Page';
import Scrollbar from 'src/components/Scrollbar';
import { LoadingButton } from '@material-ui/lab';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { empty } from 'src/Helpers/Common';
import { forwardRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useTheme } from '@emotion/react';
import useCompanyProfile from 'src/hooks/useCompanyProfile';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { Print } from "@material-ui/icons";
import { GetApp } from "@material-ui/icons";



// Styled Components
const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

export default function CompareJobCost({ id }) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedProjects1, setSelectedProjects1] = useState([]);
  const [materialPayOut, setMaterialPayOut] = useState(0);
  const [materialPayOut1, setMaterialPayOut1] = useState(0);
  const [manualTotalPayOut, setManualTotalPayOut] = useState(0);
  const [hourlyTotalPayOut, setHourlyTotalPayOut] = useState(0);
  const [excessHourlyPayoutAmount, setExcessHourlyPayoutAmount] = useState(0)
  const [excessManualPayoutAmount, setExcessManualPayoutAmount] = useState(0)
  const [additionalServices, setAdditionalServices] = useState([])
  const [projectData, setProjectData] = useState([])
  const [recipe, setRecipe] = useState([])
  // const [services, setServices] = useState([]);
  const [services, setAllServices] = useState([]);
  const [stockProducts, setStockProducts] = useState([])
  const [jobCost, setJobCost] = useState(0);
  const [loading, setLoading] = useState(false);
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [productList, setProductList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const params = localStorage.getItem("params");
  const user = JSON.parse(window.localStorage.getItem('user'))
  const [allPayouts, setAllPayouts] = useState([])
  const [manuallyAddedPayouts, setManuallyAddedPayouts] = useState([])
  const [totalManualHours, setTotalManualHours] = useState(0);
  const [staffTimelogsGet, setStaffTimelogsGet] = useState([])

    const [data, setData] = useState({});
    const fetchDetails = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
        if (res.data.status === 1) {
          setData(...res.data.data);
        }
      } catch (error) {
        console.log('get-companyProfile-details error : ', error);
      }
    };

  const fetchData = () => {
    try {
      setLoading(true)
      axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`,
        { userId: user.user_id,userType: user.user_type, projectId: id, orderId: params }).then((response) => {
        const productListData = response.data.results
        let selectedProducts = response.data.selectedMaterials
        // let selectedProducts = [
        //   ...(response.data.selectedMaterials || []), 
        //   ...(response.data.materials || [])
        // ];
        let receivedRfpProducts=selectedProducts.filter(row=>row.rfp===1)
        let rfpProducts = receivedRfpProducts.map(product => ({
            ...product,
            jobcost_unit_cost: product.unit_cost,
            jobcost_quantity: product.quantity,
            jobcost_actual_unit_cost: product.actual_unit_cost,
            jobcost_actual_quantity: product.actual_quantity
        }));
        selectedProducts=selectedProducts.filter(row=>row.rfp===0)
        let initialData = response.data.selectedMaterials
        const allPayouts = response.data.allPayOut
        const project = response.data.projects
        const allMaterials = response.data.allMaterials
        const allRecipes = response.data.allRecipies
        const material = response.data.materials
        let allServices = response.data.allServices
        let stockProducts = response?.data?.stockProducts
        let additionalServices = response.data.additionalServices
        if (additionalServices) {
          setAdditionalServices(additionalServices.reduce((accumulator, currentValue) => {
            return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
          }, 0))
        }
        if (project) {
          setProjectData(project)
        }
        if (allRecipes) {
          setRecipe(allRecipes)
        }
        if (response.data.newstafftimelogs) {
          setStaffTimelogsGet(response.data?.newstafftimelogs);
        }
        if (material?.length > 0) {
          setMaterialPayOut(
            material
              ?.filter(curr => curr.notFromRecipe != true)
              .reduce((acc, curr) => acc + curr.actual_total, 0)
          );
          
          setMaterialPayOut1(
            material
              ?.filter(curr => curr.notFromRecipe == true)
              .reduce((acc, curr) => acc + curr.total, 0)
          );          
        }
        if (allServices) {
          setAllServices(allServices)
        }
        if (stockProducts) {
          setStockProducts(stockProducts)
        }
        if (allPayouts?.length > 0) {
          let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
          const totalHourlyPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay === 1 && !payout.service_id && !payout.is_manually_added)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessHourlyPayoutAmount(totalHourlyPayoutAmount)
          const totalManualPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay !== 1 && !payout.service_id && !payout.is_manually_added)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessManualPayoutAmount(totalManualPayoutAmount)

          const summedHourlyPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay === 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedHourlyPayouts===',summedHourlyPayouts);

          const summedManualPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay !== 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedManualPayouts===',summedManualPayouts);
          
          setHourlyTotalPayOut(summedHourlyPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          setManualTotalPayOut(summedManualPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          // setHourlyTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay === 1).reduce((acc, curr) => acc + curr.amount, 0))
          // setManualTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay !== 1).reduce((acc, curr) => acc + curr.amount, 0))
        }
        if (allPayouts) {
          setAllPayouts(allPayouts || [])
          
          // Store only manually added payouts in separate state
          const manualPayouts = allPayouts.filter(
            p => (p.is_manually_added === 1 || p.is_manually_added === "1") && 
                 (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id)
          );
          setManuallyAddedPayouts(manualPayouts || []);
        }
        if (initialData) {
          setInitialMaterials(initialData)
        }
        if (productListData) {
          setProductList(productListData)
        }
        if (allMaterials) {
          setMaterialList(allMaterials)
        }
        if (project) {
          setJobCost(project.cost || 0)
        }
        if (selectedProducts?.length > 0 || material?.length > 0) {
          const selectedProjects1 = selectedProducts?.map(selectedProduct => {
            const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
            if (matchingProduct) {
              return {
                ...matchingProduct,
                product_id: selectedProduct.product_id,
                jobcost_quantity: selectedProduct.quantity,
                jobcost_unit_cost: selectedProduct.unit_price,
                jobcost_total: selectedProduct.total,
                jobcost_actual_quantity: selectedProduct.actual_quantity,
                jobcost_actual_unit_cost: selectedProduct.actual_unit_price,
                recipeName: selectedProduct.recipeName,
                taken:selectedProduct.taken,
                task_id:selectedProduct.task_id
              };
            }
            return null; // Handle cases where no matching product is found
          }).filter(project => project !== null);
          const selectedProjects2 = material?.map(selectedProduct => {
            const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
            if (matchingProduct) {
              return {
                ...matchingProduct,
                product_id: selectedProduct.product_id,
                jobcost_quantity: selectedProduct.quantity,
                jobcost_unit_cost: selectedProduct.unit_price,
                jobcost_total: selectedProduct.total,
                jobcost_actual_quantity: selectedProduct.actual_quantity,
                jobcost_actual_unit_cost: selectedProduct.actual_unit_price,
                recipeName: selectedProduct.recipeName,
                taken:selectedProduct.taken,
                task_id:selectedProduct.task_id
              };
            }
            return null; // Handle cases where no matching product is found
          }).filter(project => project !== null);
          setSelectedProjects([...selectedProjects1,...rfpProducts]);
          setSelectedProjects1([...selectedProjects2]);

          const materialPayOut = selectedProjects2
            ?.filter(curr => curr.notFromRecipe != true)
            .reduce((acc, curr) => acc + curr.jobcost_actual_quantity * curr.jobcost_actual_unit_cost, 0);

          const materialPayOut1 = selectedProjects2
            ?.filter(curr => curr.notFromRecipe != true)
            .reduce((acc, curr) => acc + curr.jobcost_total, 0);

          console.log('Material PayOut (Not From Recipe):', materialPayOut);
          console.log('Material PayOut1 (From Recipe):', materialPayOut1);

          setMaterialPayOut(materialPayOut);
          setMaterialPayOut1(materialPayOut1);

        }
      })  
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 500);
    }
  }

  useEffect(() => {
    fetchData();
    fetchDetails()
  }, [id]);

    useEffect(() => {
    const totalHours = staffTimelogsGet
      ?.filter(log => log.is_manually_added === 1 || log.is_manually_added === "1")
      ?.reduce((accumulator, currentValue) => {
        return accumulator + (parseFloat(currentValue.hours) || 0);
      }, 0) || 0;
    setTotalManualHours(totalHours);
  }, [staffTimelogsGet]);

  // Calculate manual hours cost
  const manualHoursCost = useMemo(() => {
    return staffTimelogsGet
      ?.filter(log => log.is_manually_added === 1 || log.is_manually_added === "1")
      ?.reduce((sum, log) => sum + (parseFloat(log.amount) || 0), 0) || 0;
  }, [staffTimelogsGet]);

  const totalStockCost = useMemo(() => (
  stockProducts.reduce((sum, item) => {
    const cost = parseFloat(item.location_quantity || 0) * parseFloat(item.product_retail_price || 0);
    return sum + cost;
  }, 0)
), [stockProducts]);
console.log('totalStockCosttotalStockCost 1',totalStockCost)

const totalStockCost1 = useMemo(() => (
  stockProducts.reduce((sum, item) => {
    if (item?.taken !== 1) return sum;

    const cost = parseFloat(item.jobcost_total_cost || 0);
    return sum + cost;
  }, 0)
), [stockProducts]);
console.log('totalStockCosttotalStockCost 2',totalStockCost1)

  const manuallyAddedPayoutsTotal = useMemo(() => {
    return manuallyAddedPayouts?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  }, [manuallyAddedPayouts]);

  const grandTotalCost = useMemo(() => {
    const selectedProjectsCost = selectedProjects.reduce(
      // (acc, proj) => acc + (proj.jobcost_actual_unit_cost) * proj.jobcost_actual_quantity,
      // (acc, proj) => acc + (Number(proj.jobcost_total)), //* proj.jobcost_actual_quantity,
      //{fCurrency((project.jobcost_actual_unit_cost || project.unit_cost) * project.jobcost_actual_quantity)}
      (acc, proj) => {
        // Use `jobcost_total` if available; otherwise, calculate using unit cost and quantity
        const totalCost = proj.jobcost_total 
          ? Number(proj.jobcost_total) 
          : (Number(proj.jobcost_actual_unit_cost || proj.unit_cost || 0) * Number(proj.jobcost_actual_quantity || 0));
    
        return acc + totalCost;
      }, 0
    );
    // const selectedProjectsCost = selectedProjects.reduce(
    //   (acc, proj) => acc + (Number(proj.jobcost_actual_unit_cost) || 0) * (Number(proj.jobcost_actual_quantity) || 0),
    //   0
    // );    

    // const servicesCost = services.reduce(
    //   (acc, serv) => acc + serv.jobcost_unit_cost * serv.jobcost_quantity,
    //   0
    // );


    const servicesCost = services.reduce((sum, service) => {
      // if (service.recipe_id == null) {
        const quantity = parseFloat(service.qty || 0);
        const unitCost = parseFloat(service.originalCost || service.unit_cost || 0);
        return sum + (quantity * unitCost);
      // }
      return sum;
    }, 0);
    return (
      materialPayOut +
      selectedProjectsCost +
      servicesCost +
      totalStockCost
      // + Math.max(0, manualTotalPayOut + hourlyTotalPayOut - servicesCost)
    );
  }, [selectedProjects, services, materialPayOut, manualTotalPayOut, hourlyTotalPayOut,stockProducts]);

  const grandTotalCost1 = useMemo(() => {
    const selectedProjectsCost = selectedProjects?.filter(i => i.taken==1)?.reduce(
      (acc, proj) => acc + proj.jobcost_total,
      0
    );

    // const servicesCost = services?.filter(i => i.taken==1)?.reduce(
    //   (acc, serv) => acc + serv.jobcost_unit_cost * serv.jobcost_quantity,
    //   0
    // );

    const servicesCost = services.reduce((sum, service) => {
      if (projectData?.job_category_name === 'Time & Material') {
        // if (service.recipe_id == null) {
        if (service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
        }
      } else {
        // if (service.recipe_id == null) {
        if (service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
          // const quantity = parseFloat(service.jobcost_quantity || service.qty || 0);
          // const unitCost = parseFloat(service.jobcost_unit_cost || service.originalCost || service.unit_cost || 0);
          // return sum + (quantity * unitCost);
        }
      }
      return sum;
    }, 0);

    console.log('grandtotal1==materialPayOut1==',materialPayOut1)
    console.log('grandtotal1==selectedProjectsCost==',selectedProjectsCost)
    console.log('grandtotal1==servicesCost==',servicesCost)
    console.log('grandtotal1==manualTotalPayOut==',manualTotalPayOut)
    console.log('grandtotal1==hourlyTotalPayOut==',hourlyTotalPayOut)
    const additionalAmount = ((excessManualPayoutAmount || 0) + (excessHourlyPayoutAmount || 0)) || 0
    console.log('grandtotal1==additionalAmount==',additionalAmount)
    return (
      materialPayOut1 +
      selectedProjectsCost +
      servicesCost +
      totalStockCost1 +
      manuallyAddedPayoutsTotal +
      Math.max(0, additionalAmount)
      // Math.max(0, manualTotalPayOut + hourlyTotalPayOut - servicesCost)
    );
  }, [selectedProjects, services, materialPayOut1, manualTotalPayOut, hourlyTotalPayOut, totalStockCost1, manuallyAddedPayoutsTotal]);

  const grandTotalCost2 = useMemo(() => {
    const selectedProjectsCost = selectedProjects?.filter(i => i.taken==1)?.reduce(
      (acc, proj) => acc + proj.jobcost_total,                
      0
    );

    // const servicesCost = services?.filter(i => i.taken==1)?.reduce(
    //   (acc, serv) => acc + serv.jobcost_unit_cost * serv.jobcost_quantity,
    //   0
    // );

    const servicesCost = services.reduce((sum, service) => {
      if (projectData?.job_category_name === 'Time & Material') {
        // if (service.recipe_id == null) {
        if (service.recipe_id != null && service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
        }
      } else {
        // if (service.recipe_id == null) {
        if (service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
        }
      }
      return sum;
    }, 0);

    console.log('grandtotal2==materialPayOut1==',materialPayOut1)
    console.log('grandtotal2==selectedProjectsCost==',selectedProjectsCost)
    console.log('grandtotal2==servicesCost==',servicesCost)
    console.log('grandtotal2==manualTotalPayOut==',manualTotalPayOut)
    console.log('grandtotal2==hourlyTotalPayOut==',hourlyTotalPayOut)
    const calculatedSumWithoutMax = Number(manualTotalPayOut) + Number(hourlyTotalPayOut) - Number(0);
    console.log('grandtotal2==calculatedSumWithoutMax:', calculatedSumWithoutMax);
    const calculatedSum = Math.max(0, Number(manualTotalPayOut) + Number(hourlyTotalPayOut) - Number(0))
    console.log('grandtotal2==calculatedSum==',calculatedSum)

    if (isNaN(materialPayOut1)) console.log('materialPayOut1 is NaN');
    if (isNaN(selectedProjectsCost)) console.log('selectedProjectsCost is NaN');
    if (isNaN(servicesCost)) console.log('servicesCost is NaN');
    if (isNaN(manualTotalPayOut)) console.log('manualTotalPayOut is NaN');
    if (isNaN(hourlyTotalPayOut)) console.log('hourlyTotalPayOut is NaN');
    if (isNaN(calculatedSum)) console.log('calculatedSum is NaN');

    return (
      materialPayOut1 +
      selectedProjectsCost +
      servicesCost 
      +
      Math.max(0, manualTotalPayOut) // - servicesCost
      // Math.max(0, manualTotalPayOut + hourlyTotalPayOut) // - servicesCost
    );
  }, [selectedProjects, services, materialPayOut1, manualTotalPayOut, hourlyTotalPayOut]);

  const additionalLaborCost = useMemo(() => (
    services.reduce((sum, service) => {
      if (service.labour_cost_service_id === 10) return sum;
      if (service.recipe_id == null) {
        const quantity = parseFloat(service.qty || 0);
        const unitCost = parseFloat(service.originalCost || service.unit_cost || 0);
        return sum + (quantity * unitCost);
      }
      // else {
      //   const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
      //   return sum + jobcost_total_cost;
      // }
      // if (service.recipe_id == null) {
      //   return sum + service.jobcost_unit_cost * service.jobcost_quantity;
      // }
      return sum;
    }, 0)
  ), [services]);

    const excessLabourOnly = useMemo(() => {
    let labourExpected = 0;
    let labourActual = 0;
  
    services.forEach(service => {
      if (+service.labour_cost_service_id === 10) {
        const expected = parseFloat(service.originalCost) || 0;
        const actual = parseFloat(service.jobcost_total_cost) || 0;
        labourExpected += expected;
        labourActual += actual;
      }
    });
  
    return labourActual > labourExpected
      ? +(labourActual - labourExpected).toFixed(2)
      : 0;
  }, [services]);

  console.log('additionalLaborCost=====',additionalLaborCost)
  console.log('services=====',services)
  console.log('selectedProjects=====',selectedProjects)
  // const additionalLaborCost1 = useMemo(() => (
  //   services.reduce((sum, service) => {
  //     if (service.labour_cost_service_id === 10) return sum;
  //     // if(projectData?.job_category_name=='Time & Material'){
  //     //   const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
  //     //   if (service.recipe_id == null && service.taken == 1) {
  //     //     return sum + jobcost_total_cost;
  //     //   }else{
  //     //     return sum + 0
  //     //   }
  //     // }else{
  //       const quantity = parseFloat(service.jobcost_quantity || service.qty || 0);
  //       const unitCost = parseFloat(service.jobcost_unit_cost || service.originalCost || service.unit_cost || 0);
  //       const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
  //       if (service.recipe_id == null && service.labour_cost_service_id == 10 && service.taken == 1) {
  //         return sum + jobcost_total_cost;
  //       }else if (service.recipe_id == null && service.taken == 1) {
  //         // return sum + (quantity * unitCost);
  //         return sum + jobcost_total_cost;
  //       }else{
  //         return sum + 0
  //       }
  //     // }
  //     // if (service.recipe_id == null) {
  //     //   return sum + service.jobcost_unit_cost * service.jobcost_quantity;
  //     // }
  //     return sum;
  //   }, 0)
  // ), [services]);

  // const productFormulaCost = useMemo(() => (
  //   selectedProjects?.reduce((sum, proj) => sum + (proj.jobcost_actual_unit_cost || proj.unit_cost) * proj.jobcost_actual_quantity, 0) +
  //   services.reduce((sum, serv) => (serv.recipe_id ? sum + serv.jobcost_unit_cost * serv.jobcost_quantity : sum), 0)
  // ), [selectedProjects, services]);

    const additionalLaborCost1 = useMemo(() => (
    services.reduce((sum, service) => {
      if (service?.taken !== 1 || service.recipe_id != null || service.labour_cost_service_id === 10) return sum;
  
      const expected = parseFloat((service.originalCost * service.qty) || 0);
      const actual   = parseFloat(service.jobcost_total_cost || 0);
  
  
      const nonExcessAmount = actual > expected ? expected : actual;
  
  
       return sum + nonExcessAmount;
    }, 0)
  ), [services]);
  
  // const productFormulaCost = useMemo(() => (
  //   (selectedProjects?.reduce(
  //     (sum, proj) => sum + (Number(proj.jobcost_actual_unit_cost) || Number(proj.unit_cost)) * Number(proj.jobcost_actual_quantity), 
  //     0
  //   ) || 0) +
  //   (services?.reduce(
  //     (sum, serv) => ((serv.recipe_id != null || serv?.labour_cost_service_id === 10) ? sum + serv.originalCost * serv.qty : sum), 
  //     0
  //   ) || 0)
  // ), [selectedProjects, services]);

  const productFormulaCost = useMemo(() => {
    const filtered = services?.filter(
      s => s?.recipe_id && s?.labour_cost_service_id !== 10
    );

    // const expected = filtered.reduce(
    //   (sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0
    // );
    // const actual = filtered.reduce(
    //   (sum, s) => sum + parseFloat(s.jobcost_total_cost || 0), 0
    // );

    // const used = Math.min(expected, actual);
    const expected = filtered.reduce(
    (sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0),
    0
  );

  return expected.toFixed(2);

    // return used.toFixed(2);
  }, [services]);


  // const productFormulaCost = useMemo(() => {
  //   return services?.reduce((acc, s) => {
  //     if (s?.recipe_id && s?.labour_cost_service_id !== 10 ) {
  //       const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
  //       const actual = parseFloat(s.jobcost_total_cost || 0);
  //       const cost = expected > actual ? actual : expected;
  //       return acc + cost;
  //     }
  //     return acc;
  //   }, 0).toFixed(2);
  // }, [services]);

  // const materialTotal = useMemo(() => {
  //   return selectedProjects?.reduce((sum, proj) => {
  //     const unitCost = Number(proj.jobcost_actual_unit_cost || proj.unit_cost || 0);
  //     const quantity = Number(proj.jobcost_actual_quantity || 0);
  //     return sum + (unitCost * quantity);
  //   }, 0).toFixed(2);
  // }, [selectedProjects]);

  const materialTotal = useMemo(() => {
  const combined = [...(selectedProjects || []), ...(selectedProjects1 || [])];

  return combined.reduce((sum, proj) => {
    const unitCost = Number(proj.jobcost_actual_unit_cost || proj.unit_cost || 0);
    const quantity = Number(proj.jobcost_actual_quantity || 0);
    return sum + (unitCost * quantity);
  }, 0).toFixed(2);
}, [selectedProjects, selectedProjects1]);


  const materialTotal1 = useMemo(() => {
    return selectedProjects?.reduce((acc, project) => {
      if (project?.taken === 1) {
        return acc + (parseFloat(project?.jobcost_total) || 0);
      }
      return acc;
    }, 0).toFixed(2);
  }, [selectedProjects]);

console.log('materialCostmaterialCost',materialTotal1)
  // const productFormulaCost1 = useMemo(() => (
  //   selectedProjects?.filter(i => i.taken==1)?.reduce((sum, proj) => sum + proj.jobcost_total, 0) +
  //   services?.filter(i => i.taken==1)?.reduce((sum, serv) => (serv.recipe_id ? sum + serv.jobcost_unit_cost * serv.jobcost_quantity : sum), 0)
  // ), [selectedProjects, services]);
  console.log('selectedProjects=1===',selectedProjects);
  console.log('selectedProjects=2===',services);

  // const productFormulaCost1 = useMemo(() => (
  //   (selectedProjects?.reduce((accumulator, currentValue) => {
  //     let newTotal = 0;
  //     if(currentValue?.taken == 1){
  //       // newTotal = currentValue?.jobcost_total
  //       const initialCost = currentValue?.originalCost * currentValue?.qty
  //       newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
  //       // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.unit_cost * currentValue?.quantity
  //     }
  //     return accumulator + newTotal;
  //   }, 0) + services?.reduce((accumulator, currentValue) => {
  //     let newTotal = 0;
  //     if((currentValue.recipe_id || currentValue?.labour_cost_service_id === 10) && currentValue?.taken == 1){
  //       // newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
  //       const initialCost = currentValue?.originalCost * currentValue?.qty
  //       newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
  //       // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.originalCost * currentValue?.qty
  //     }
  //     return accumulator + newTotal;
  //   }, 0)).toFixed(2) // - excessLabourOnly || 0
  //   // (selectedProjects?.reduce(
  //   //   (sum, proj) => (proj.taken == 1 && !empty(proj.recipeName) ? sum + proj.jobcost_total : sum), 
  //   //   0
  //   // ) || 0) +
  //   // (services?.reduce(
  //   //   (sum, serv) => (serv.taken == 1 && (serv.recipe_id != null || serv?.labour_cost_service_id === 10) ? sum + serv.jobcost_unit_cost * serv.jobcost_quantity : sum), 
  //   //   0
  //   // ) || 0)
  // ), [selectedProjects, services]);

    const productFormulaCost1 = useMemo(() => {
  const filtered = services?.filter(
    s => s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1
  );

  const expected = filtered.reduce((sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0);
  const actual   = filtered.reduce((sum, s) => sum + parseFloat(s.jobcost_total_cost || 0), 0);
    
    // For regular services: use Math.min(expected, actual)
    // For manually added tasks: add actual cost directly (no expected cost)
    const regularProductionLabour = Math.min(expected, actual);
    const used = regularProductionLabour + manuallyAddedPayoutsTotal;

  console.log('🧮 [Production Labour]');
  console.log('→ Production Labour Expected Total:', expected);
  console.log('→ Production Labour Actual Total:', actual);
  console.log('→ Production Labour Used Total:', used);
  console.log('→ Manually Added Tasks Payouts:', manuallyAddedPayoutsTotal);

  return used.toFixed(2);
}, [services, manuallyAddedPayoutsTotal]);
  
// const productFormulaCost1 = useMemo(() => {
//   return services?.reduce((acc, s) => {
//     if (s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1) {
//       const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
//       const actual = parseFloat(s.jobcost_total_cost || 0);
//       const cost = expected > actual ? actual : expected;
//       return acc + cost;
//     }
//     return acc;
//   }, 0).toFixed(2);
// }, [services]);

  const excessLaborCost = 0;
  // const excessLaborCost = useMemo(() => (
  //   Math.max(0, manualTotalPayOut + hourlyTotalPayOut - additionalLaborCost)
  // ), [manualTotalPayOut, hourlyTotalPayOut, additionalLaborCost]);

  // const excessLaborCost1 = useMemo(() => (
  //   Math.max(0, manualTotalPayOut - additionalLaborCost1)
  //   // Math.max(0, manualTotalPayOut + hourlyTotalPayOut - additionalLaborCost1)
  // ), [manualTotalPayOut, hourlyTotalPayOut, additionalLaborCost1]);

  const excessLaborCost1 = useMemo(() => {
    let labourExpected = 0;
    let labourActual = 0;
    let otherExcess = 0;
    let productionExpected = 0;
    let productionActual = 0;
  
    services.forEach(s => {
      const expected = s.taken == 1 ? (parseFloat(s.originalCost * s.qty) || 0) : 0;
      const actual = s.taken == 1 ? (parseFloat(s.jobcost_total_cost) || 0) : 0;
  
      if (+s.labour_cost_service_id === 10) {
  // install labour
        labourExpected += expected;
        labourActual += actual;
      } else if (s.recipe_id && s.labour_cost_service_id !== 10 && s.taken == 1) {
  // production labour
        productionExpected += expected;
        productionActual += actual;
      } else {
  // Per-row excess calculation for others
        if (actual > expected) {
          otherExcess += actual - expected;
        }
      }
    });
  
    const labourExcess = labourActual > labourExpected ? labourActual - labourExpected : 0;
    const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;
  
    return +(
      labourExcess +
      productionExcess +
      otherExcess +
      (excessHourlyPayoutAmount || 0) +
      (excessManualPayoutAmount || 0)
    ).toFixed(2);
  }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual   = 0;
//   let otherExcess    = 0;

//   services.forEach(r => {
//     const expected = r.taken == 1 ? (parseFloat(r.originalCost * r.qty) || 0) : 0;
//     const actual   = r.taken == 1 ? (parseFloat(r.jobcost_total_cost) || 0) : 0;

//     if (+r.labour_cost_service_id === 10) {
//       // Group totals for labour id 10
//       labourExpected += expected;
//       labourActual   += actual;
//     } else {
//       // Per-row excess calculation for others
//       if (actual > expected) {
//         otherExcess += actual - expected;
//       }
//     }
//   });

//   const labourExcess = labourActual > labourExpected
//     ? labourActual - labourExpected
//     : 0;

//   return +(labourExcess + otherExcess + (excessHourlyPayoutAmount || 0) + (excessManualPayoutAmount || 0)).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

const installLaborCost = useMemo(() => {
  // return services?.reduce((acc, s) => {
  //   if (s?.labour_cost_service_id === 10) {
  //     const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
  //     const actual = parseFloat(s.jobcost_total_cost || 0);
  //     const cost = expected > actual ? actual : expected;
  //     return acc + cost;
  //   }
  //   return acc;
  // }, 0).toFixed(2);
  const filtered = services?.filter(
    s => s?.labour_cost_service_id === 10
  );

  const expected = filtered.reduce(
    (sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0),
    0
  );

  return expected.toFixed(2);
}, [services]);

const installLaborCost1 = useMemo(() => {
  return services?.reduce((acc, s) => {
    if (s?.labour_cost_service_id === 10 && s?.taken == 1) {
      const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
      const actual = parseFloat(s.jobcost_total_cost || 0);
      const cost = expected > actual ? actual : expected;
      return acc + cost;
    }
    return acc;
  }, 0).toFixed(2);
}, [services]);

  const formik = useFormik({
    initialValues: {},
    validationSchema: Yup.object().shape({}),
    onSubmit: () => {}
  });

  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF();
  
  //   doc.setFontSize(16);
  //   doc.text('Expected Budget', 14, 15);
  
  //   // Expected Budget Table
  //   autoTable(doc, {
  //     startY: 20,
  //     head: [['Name', 'Product Formula', 'Qty / Hrs', 'Total']],
  //     body: [
  //       ...selectedProjects.map((proj) => [
  //         proj.name,
  //         proj.recipeName || '',
  //         proj.jobcost_actual_quantity,
  //         fCurrency(
  //           (proj.jobcost_actual_unit_cost || proj.unit_cost) *
  //             proj.jobcost_actual_quantity
  //         ),
  //       ]),
  //       ...selectedProjects1
  //         .filter((d) => d.notFromRecipe !== true)
  //         .map((proj) => [
  //           proj.name,
  //           '',
  //           proj.jobcost_actual_quantity,
  //           fCurrency(
  //             proj.jobcost_actual_unit_cost * proj.jobcost_actual_quantity
  //           ),
  //         ]),
  //       ...services.map((serv) => [
  //         serv.name,
  //         serv.recipeName || '',
  //         serv.qty,
  //         fCurrency(
  //           (serv.qty * (serv.originalCost || serv.unit_cost)).toFixed(2)
  //         ),
  //       ]),
  //     ],
  //     didDrawPage: function (data) {
  //       const summaryStartY = data.cursor.y + 10;
  
  //       doc.setFontSize(12);
  //       doc.text('Additional Material Cost:', 14, summaryStartY);
  //       doc.text(fCurrency(materialPayOut), 170, summaryStartY, { align: 'right' });
  
  //       doc.text('Additional Services:', 14, summaryStartY + 7);
  //       doc.text(fCurrency(additionalLaborCost), 170, summaryStartY + 7, { align: 'right' });
  
  //       doc.text('Actual Product Formula Cost:', 14, summaryStartY + 14);
  //       doc.text(fCurrency(productFormulaCost), 170, summaryStartY + 14, { align: 'right' });
  
  //       doc.text('Excess Labor Cost:', 14, summaryStartY + 21);
  //       doc.text(fCurrency(excessLaborCost), 170, summaryStartY + 21, { align: 'right' });
  
  //       doc.setFontSize(14);
  //       doc.setTextColor(252, 140, 3); // orange
  //       doc.text('Total Cost:', 14, summaryStartY + 30);
  //       doc.text(fCurrency(grandTotalCost), 170, summaryStartY + 30, { align: 'right' });
  
  //       // Start new section
  //       const actualStartY = summaryStartY + 45;
  //       doc.setFontSize(16);
  //       doc.setTextColor(0, 0, 0);
  //       doc.text('Actual Budget', 14, actualStartY);
  
  //       autoTable(doc, {
  //         startY: actualStartY + 5,
  //         head: [['Name', 'Product Formula', 'Qty / Hrs', 'Total']],
  //         body: [
  //           ...selectedProjects
  //             .filter((i) => i.taken === 1)
  //             .map((proj) => [
  //               proj.name,
  //               proj.recipeName || '',
  //               proj.jobcost_quantity,
  //               fCurrency(proj.jobcost_total),
  //             ]),
  //           ...selectedProjects1
  //             .filter((d) => d.notFromRecipe !== true && d.jobcost_quantity > 0)
  //             .map((proj) => [
  //               proj.name,
  //               '',
  //               proj.jobcost_quantity,
  //               fCurrency(proj.jobcost_total),
  //             ]),
  //           ...services
  //             .filter((s) => s.taken === 1)
  //             .map((serv) => [
  //               serv.name,
  //               serv.recipeName || '',
  //               serv.jobcost_quantity,
  //               fCurrency(serv.jobcost_total_cost),
  //             ]),
  //         ],
  //         didDrawPage: function (actualData) {
  //           const actualSummaryY = actualData.cursor.y + 10;
  
  //           doc.setFontSize(12);
  //           doc.setTextColor(0, 0, 0);
  //           doc.text('Additional Material Cost:', 14, actualSummaryY);
  //           doc.text(fCurrency(materialPayOut1), 170, actualSummaryY, { align: 'right' });
  
  //           doc.text('Additional Services:', 14, actualSummaryY + 7);
  //           doc.text(fCurrency(additionalLaborCost1), 170, actualSummaryY + 7, { align: 'right' });
  
  //           doc.text('Actual Product Formula Cost:', 14, actualSummaryY + 14);
  //           doc.text(fCurrency(productFormulaCost1), 170, actualSummaryY + 14, { align: 'right' });
  
  //           doc.text('Excess Labor Cost:', 14, actualSummaryY + 21);
  //           doc.text(fCurrency(excessLaborCost1), 170, actualSummaryY + 21, { align: 'right' });
  
  //           doc.setFontSize(14);
  //           doc.setTextColor(252, 140, 3); // orange
  //           doc.text('Total Cost:', 14, actualSummaryY + 30);
  //           doc.text(
  //             fCurrency(
  //               projectData?.job_category_name === 'Time & Material'
  //                 ? grandTotalCost2
  //                 : grandTotalCost1
  //             ),
  //             170,
  //             actualSummaryY + 30,
  //             { align: 'right' }
  //           );
  
  //           // Save after all tables and summaries
  //           doc.save('Job-Cost-Report.pdf');
  //         },
  //       });
  //     },
  //   });
  // };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  
    doc.setFontSize(14);
    doc.text('Expected Budget', 40, 40);
  
    // Expected Budget Table
    autoTable(doc, {
      startY: 50,
      head: [['Name', 'Product Formula', 'Quantity / Hrs', 'Total']],
      body: [
        ...selectedProjects.map((proj) => [
          proj.name,
          proj.recipeName || '',
          proj.jobcost_actual_quantity,
          fCurrency((proj.jobcost_actual_unit_cost || proj.unit_cost) * proj.jobcost_actual_quantity),
        ]),
        ...selectedProjects1
          .filter((d) => d.notFromRecipe !== true && d.jobcost_actual_quantity > 0)
          .map((proj) => [
            proj.name,
            '',
            proj.jobcost_actual_quantity,
            fCurrency(proj.jobcost_actual_unit_cost * proj.jobcost_actual_quantity),
          ]),
          ...stockProducts.map((proj) => [
          proj.product_name,
          proj.recipeName || '',
          proj.location_quantity,
          fCurrency((proj.product_retail_price) * proj.location_quantity),
        ]),
        // ...services.map((serv) => [
          ...services?.reduce((acc, curr) => {

            if (curr.labour_cost_service_id === 10) {
              if (!acc.some(item => item.labour_cost_service_id === 10)) {
                const combined = { ...curr };
                const sameItems = services.filter(s => s.labour_cost_service_id === 10);

                combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);

                acc.push(combined);
              }
            }

            else if (curr.recipe_id != null) {
              const alreadyAdded = acc.some(item => item.__isRecipeGroup);
              if (!alreadyAdded) {
                const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                if (recipeItems.length > 0) {
                  const combined = { ...recipeItems[0] };
                  combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                  combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                  combined.jobcost_total_cost = recipeItems
                  .reduce((sum, s) => sum + (Number(s.qty || 0) * Number(s.originalCost || s.unit_cost || 0)), 0)
                  .toFixed(2);
                  combined.__isRecipeGroup = true;
                  acc.push(combined);
                }
              }
            }
            else {
              acc.push(curr);
            }

            return acc;
          }, [])
          .map((serv, index) => [
          serv.__isRecipeGroup ? 'Production Labor' : serv.name,
          serv.__isRecipeGroup ? '' : serv.recipeName || '',
          serv.qty,
          fCurrency(
            serv.__isRecipeGroup
              ? serv.jobcost_total_cost
              : Number((serv.qty * (serv.originalCost || serv.unit_cost)).toFixed(2))
          )
        ]),
      ],
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: 'bold',
        lineWidth: 0.1,
        lineColor: 200
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },
      bodyStyles: {
        textColor: 0
      },
      tableLineColor: 200,
      tableLineWidth: 0.1,
      theme: 'grid'
    });
  
    let posY = doc.lastAutoTable.finalY + 30;
  
    // Summary below Expected
    const expectedSummary = [
      // ['Additional Material Cost', fCurrency(materialTotal)],
          ['Additional Material Cost', fCurrency(
        (Number(materialTotal || 0) + Number(totalStockCost || 0)).toFixed(2)
      )],
      ['Additional Services', fCurrency(additionalLaborCost)],
      ['Production Labor', fCurrency(productFormulaCost)],
      ['Install Labor',fCurrency(installLaborCost)],
      ['Excess Labor Cost', fCurrency(excessLaborCost)],
      ['Total Cost', fCurrency(grandTotalCost)],
    ];
    
    doc.setFontSize(10);
    expectedSummary.forEach(([label, value], i) => {
      const y = posY + i * 18;
      doc.text(label + ':', 350, y);
      doc.text(value, 540, y, { align: 'right' });
    });
  
    // Actual Budget Section
    const actualStartY = posY + 90;
    doc.setFontSize(14);
    doc.text('Actual Budget', 40, actualStartY);
  
    autoTable(doc, {
      startY: actualStartY + 10,
      head: [['Name', 'Product Formula', 'Quantity / Hrs', 'Total']],
      body: [
        ...selectedProjects.filter((p) => p.taken === 1).map((proj) => [
          proj.name,
          proj.recipeName || '',
          proj.jobcost_quantity,
          fCurrency(proj.jobcost_total),
        ]),
        ...selectedProjects1
          .filter((d) => d.notFromRecipe !== true && d.jobcost_quantity > 0)
          .map((proj) => [
            proj.name,
            '',
            proj.jobcost_quantity,
            fCurrency(proj.jobcost_total),
          ]),
          ...stockProducts.map((proj) => [
          proj.product_name,
          '',
          proj.jobcost_quantity,
          fCurrency((proj.product_retail_price) * proj.jobcost_quantity),
        ]),
        // ...services.filter((s) => s.taken === 1).map((serv) =>
          ...services
              ?.reduce((acc, curr) => {
                // ✅ Case 1: Consolidate install labour
                if (curr.labour_cost_service_id === 10) {
                  const alreadyAdded = acc.some(item => item.labour_cost_service_id === 10);
                  if (!alreadyAdded) {
                    const sameItems = services.filter(s => s.labour_cost_service_id === 10);
                    const combined = { ...curr };

                    combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                    combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                    combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);
                    combined.taken = sameItems.some(s => s.taken === 1) ? 1 : 0;

                    acc.push(combined);
                  }
                }

                // ✅ Case 2: Consolidate all services with recipe_id (excluding labour)
                else if (curr.recipe_id != null && curr.labour_cost_service_id !== 10) {
                  const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                  if (!alreadyAdded) {
                    const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                    if (recipeItems.length > 0) {
                      const combined = { ...recipeItems[0] };

                      combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                      combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0) + totalManualHours;
                      // Use actual jobcost_total_cost from services, not expected (qty * originalCost)
                      combined.jobcost_total_cost = (recipeItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0) + manuallyAddedPayoutsTotal).toFixed(2);
                      combined.taken = recipeItems.some(s => s.taken === 1) ? 1 : 0;
                      combined.__isRecipeGroup = true;

                              acc.push(combined);
                            }
                          }
                        }

                        // ✅ Default case: push as-is
                        else {
                          acc.push(curr);
                        }

                        return acc;
                      }, [])
              .filter(i => i.taken === 1 || (i.__isRecipeGroup && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0)))
              .map((serv, index) => 
           [
          serv.__isRecipeGroup ? 'Production Labor' : serv.name,
          serv.__isRecipeGroup ? '' :serv.recipeName || '',
          serv.jobcost_quantity,
          fCurrency(serv.jobcost_total_cost),
        ]),
        // Separate Production Labor row for Time & Material projects
        ...(projectData?.job_category_name === 'Time & Material' && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0) ? [[
          'Production Labor',
          '',
          parseFloat(totalManualHours || 0).toFixed(2),
          fCurrency(manuallyAddedPayoutsTotal)
        ]] : []),
      ],
      headStyles: {
        fillColor: [255, 255, 255], // white
        textColor: 0,
        fontStyle: 'bold',
        lineWidth: 0.1,
        lineColor: 200
      },
      bodyStyles: {
        textColor: 0
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },
      tableLineColor: 200,
      tableLineWidth: 0.1,
      theme: 'grid'
    });
  
    const finalY = doc.lastAutoTable.finalY + 30;
  
    const actualSummary = [
      ['Material Cost', fCurrency((parseFloat(materialPayOut1 || 0) + parseFloat(materialTotal1 || 0) + parseFloat(totalStockCost1 || 0)).toFixed(2))],
      ['Additional Services', fCurrency(additionalLaborCost1)],
      ['Production Labor', fCurrency(productFormulaCost1)],
      ['Install Labor',fCurrency(installLaborCost1)],
      ['Excess Labor Cost', fCurrency(excessLaborCost1)],
      ['Total Cost', fCurrency(
        projectData?.job_category_name === 'Time & Material' ? grandTotalCost1 : grandTotalCost1  // grandTotalCost2
      )],
    ];
    
    doc.setFontSize(10);
    actualSummary.forEach(([label, value], i) => {
      const y = finalY + i * 18;
      doc.text(label + ':', 350, y);
      doc.text(value, 540, y, { align: 'right' });
    });
  
    doc.save('Job-Cost-Report.pdf');
  };
  
  return (
    <Page title="Job Calculator">
      <Container>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
          <ReactToPrint
                trigger={() => (<Button> <Print /> Print A3</Button>)}
                content={() => componentRef.current}
                copyStyles={false}
                pageStyle={`
                  @media print {
                    body {
                      font-size: 12pt;
                    }
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      margin-bottom: 10px;
                    }

                    th, td {
                      border: 1px solid #ddd;
                      padding: 5px;
                      text-align: left;
                    }
                    #right {
                      text-align: right;
                      margin-top: -200px; 
                    }
                    #total {
                      text-align: right;
                      display:flex;
                      justify-content: flex-end;
                    }
                    #subtotal {
                      text-align: left;
                      
                    }
                    #discount {
                      text-align: left;
                      word-wrap: break-word;
                      margin-right: 100px;
                  }
                  
                    #totalmain {
                      text-align: left;
                      
                    }
                    #subtotal1 {
                      text-align: left;
                      
                    }
                    #discount1 {
                      text-align: left;
                      word-wrap: break-word;
                      margin-right: 30px;
                  }
                  
                    #totalmain1 {
                      text-align: left;
                      
                    }
                    #total1 {
                      text-align: right;
                      display:flex;
                      justify-content: flex-end;
                      margin-top: -220px; 
                      
                    }
                    #logoImage {
                      height: 100px;
                      width:100px;
                    }
                    #order{
                      margin-bottom:-20px
                    }
                    #title{
                      margin-bottom:-20px
                    }
                    #orderID {
                      margin-bottom:-20px
                    }
                    #to {
                      margin-bottom:-20px
                    }
                    
                  }
                `}
              />
          <Button startIcon={<GetApp />} onClick={handleDownloadPDF}>
            Download
          </Button>
        </Box>
         <div style={{ display: "none" }}>
         <PrintableJobCostReport
          selectedProjects={selectedProjects}
          selectedProjects1={selectedProjects1}
          services={services}
          ref={componentRef}
          data={data}
          materialPayOut={materialPayOut}
          materialPayOut1={materialPayOut1}
          additionalLaborCost={additionalLaborCost}
          additionalLaborCost1={additionalLaborCost1}
          productFormulaCost={productFormulaCost}
          productFormulaCost1={productFormulaCost1}
          excessLaborCost={excessLaborCost}
          excessLaborCost1={excessLaborCost1}
          grandTotalCost={grandTotalCost}
          grandTotalCost1={grandTotalCost1}
          installLaborCost={installLaborCost}
          installLaborCost1={installLaborCost1}
          // grandTotalCost2={grandTotalCost2}
          grandTotalCost2={grandTotalCost1}
          projectData={projectData}
          materialTotal1={materialTotal1}
          materialTotal={materialTotal}
          totalStockCost={totalStockCost}
          totalStockCost1={totalStockCost1}
          stockProducts={stockProducts}
          totalManualHours={totalManualHours}
          manualHoursCost={manualHoursCost}
          manuallyAddedPayoutsTotal={manuallyAddedPayoutsTotal}
          />

        </div>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <Card>
              <Box sx={{ display: 'flex', alignItems: 'center', py: 2, pl: 3 }}>
                <Typography variant="h4" noWrap>
                  Expected Budget
                </Typography>
              </Box>
              <FormikProvider value={formik}>
                <Scrollbar sx={{ height: '320px' }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Name </TableCell>
                          {/* <TableCell>{projectData?.job_category_name === 'Time & Material' ? '' : 'Product Formula'}</TableCell> */}
                          <TableCell>Product Formula</TableCell>
                          <TableCell>Quantity / Hrs</TableCell>
                          {/* <TableCell>Unit Price</TableCell> */}
                          <TableCell>Total</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedProjects?.map((project, index) => (
                          <TableRow key={index}>
                            <TableCell>{project.name || project?.productName || project?.rfpProductName} {project?.barcode ? '' : "(Sub contract)"}</TableCell>
                            <TableCell>{project.recipeName || ''}</TableCell>
                            <TableCell>{project.jobcost_actual_quantity}</TableCell>
                            {/* <TableCell>{fCurrency((project.jobcost_actual_unit_cost || project.unit_cost))}</TableCell> */}
                            <TableCell>
                              {fCurrency((project.jobcost_actual_unit_cost || project.unit_cost) * project.jobcost_actual_quantity)}
                            </TableCell>
                            

                          </TableRow>
                        ))}
                        {selectedProjects1?.filter(data=>data?.notFromRecipe != true &&  data?.jobcost_actual_quantity > 0)?.map((project, index) => ( // && data?.jobcost_actual_quantity > 0
                          <TableRow key={index}>
                            <TableCell>{project.name}</TableCell>
                            <TableCell>{''}</TableCell>
                            <TableCell>{project.jobcost_actual_quantity}</TableCell>
                            {/* <TableCell>{fCurrency(project.jobcost_actual_unit_cost)}</TableCell> */}
                            <TableCell>
                              {fCurrency((project.jobcost_actual_unit_cost) * project.jobcost_actual_quantity)}
                            </TableCell>
                          </TableRow>
                        ))}
                        {stockProducts?.map((product, index) => (
                          <TableRow key={index}>
                            <TableCell>{product.product_name}</TableCell>
                            <TableCell>{''}</TableCell>
                            <TableCell>{product.location_quantity}</TableCell>
                            <TableCell>
                              {fCurrency((parseFloat(product.product_retail_price || 0)) * parseFloat(product.location_quantity || 0))}
                            </TableCell>
                          </TableRow>
                        ))}
                        {/* {services.map((service, index) => ( */}
                        {
                        // services
                        //   ?.reduce((acc, curr) => {
                        //     if (curr.labour_cost_service_id === 10) {
                        //       if (!acc.some(item => item.labour_cost_service_id === 10)) {
                        //         const combined = { ...curr }
                        //         const sameItems = services.filter(s => s.labour_cost_service_id === 10)

                        //         combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0)
                        //         combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0)
                        //         combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2)

                        //         acc.push(combined)
                        //       }
                        //     } else {
                        //       acc.push(curr)
                        //     }
                        //     return acc
                        //   }, [])
                        //   .map((service, index) => (
                          services?.reduce((acc, curr) => {
                                // ✅ Case 1: Consolidate install labour - untouched logic
                                if (curr.labour_cost_service_id === 10) {
                                  if (!acc.some(item => item.labour_cost_service_id === 10)) {
                                    const combined = { ...curr };
                                    const sameItems = services.filter(s => s.labour_cost_service_id === 10);

                                    combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                    combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                    combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);

                                    acc.push(combined);
                                  }
                                }

                                // Case 2: Consolidate ALL services that have any recipe_id (not null) but NOT labour
                                else if (curr.recipe_id != null) {
                                  const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                                  if (!alreadyAdded) {
                                    const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                    if (recipeItems.length > 0) {
                                      const combined = { ...recipeItems[0] };
                                      combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                      combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                      combined.jobcost_total_cost = recipeItems
                                      .reduce((sum, s) => sum + (Number(s.qty || 0) * Number(s.originalCost || s.unit_cost || 0)), 0)
                                      .toFixed(2);
                                      combined.__isRecipeGroup = true;
                                      acc.push(combined);
                                    }
                                  }
                                }
                                else {
                                  acc.push(curr);
                                }

                                return acc;
                              }, [])
                              .map((service, index) => (
                          <TableRow key={index}>
                            {
                            console.log('TableRow', service)

                            }
                            <TableCell style={{ color: 'yellow' }}>{service.__isRecipeGroup ? 'Production Labor' : service.name}</TableCell>
                            <TableCell style={{ color: 'yellow' }}>{service.__isRecipeGroup ? '' : service.recipeName}</TableCell>
                            <TableCell style={{ color: 'yellow' }}>{parseFloat(service.qty || 0).toFixed(2)}</TableCell>
                            {/* <TableCell style={{ color: 'yellow' }}>{fCurrency(service.jobcost_unit_cost|| service.originalCost||service.unit_cost)}</TableCell> */}
                            <TableCell style={{ color: 'yellow' }}>
                              {/* {fCurrency((service.qty * (service.originalCost||service.unit_cost))?.toFixed(2))} */}
                            {service?.__isRecipeGroup
                              ? fCurrency(service.jobcost_total_cost)
                              : fCurrency((service.qty * (service.originalCost || service.unit_cost))?.toFixed(2))}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <Box>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* {projectData?.job_category_name === 'Time & Material' ? 
                      <Typography variant="h6">Material Cost</Typography>
                    : */}
                      {/* <Typography variant="h6">Additional Material Cost</Typography> */}
                      <Typography variant="h6">Material Cost</Typography>
                    {/* } */}
                  </TableCell>
                  <TableCell align="left">
                    {/* <Typography variant="h6">{fCurrency(materialPayOut)}</Typography> */}
                    <Typography variant="h6">{fCurrency(parseFloat(materialTotal || 0) + parseFloat(totalStockCost || 0))}</Typography>
                  </TableCell>
                </RowResultStyle>
                {/* {projectData?.job_category_name === 'Time & Material' ? '' : */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                      {/* <Typography variant="h6">Services Cost</Typography> */}
                      <Typography variant="h6">Additional Services</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(additionalLaborCost)}</Typography>
                  </TableCell>
                </RowResultStyle>
                {/* } */}
                {/* {projectData?.job_category_name === 'Time & Material' ? '' : */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                    <Typography variant="h6">Production Labor</Typography>

                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(productFormulaCost)}</Typography>
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                    <Typography variant="h6">Install Labor</Typography>

                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(installLaborCost)}</Typography>
                  </TableCell>
                </RowResultStyle>
                {/* } */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">{projectData?.job_category_name === 'Time & Material'? "Service Cost":"Excess Labor Cost"}</Typography> */}
                    <Typography variant="h6">Excess Labor Cost</Typography>
                  </TableCell>
                  <TableCell align="left">
                  {/* {projectData?.job_category_name === 'Time & Material'? 
                    <Typography variant="h6">{fCurrency(additionalLaborCost)}</Typography>
                    : */}
                    <Typography variant="h6">{fCurrency(excessLaborCost)}</Typography>
                  {/* } */}
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    <Typography variant="h6" sx={{ color: '#fc8c03' }}>Total Cost</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6" sx={{ color: '#fc8c03' }}>{fCurrency(grandTotalCost)}</Typography>
                  </TableCell>
                </RowResultStyle>
                </Box>
                </Box>
              </FormikProvider>
            </Card>
          </Grid>

          <Grid item md={6} xs={12}>
            <Card>
              <Box sx={{ display: 'flex', alignItems: 'center', py: 2, pl: 3 }}>
                <Typography variant="h4" noWrap>
                  Actual Budget
                </Typography>
              </Box>
              <FormikProvider value={formik}>
                <Scrollbar sx={{ height: '320px' }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          {/* <TableCell>{projectData?.job_category_name === 'Time & Material' ? '' : 'Product Formula'}</TableCell> */}
                          <TableCell>Product Formula</TableCell>
                          <TableCell>Quantity / Hrs</TableCell>
                          {/* <TableCell>Unit Price</TableCell> */}
                          <TableCell>Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedProjects?.filter(i => i.taken==1)?.map((project, index) => (
                          <TableRow key={index}>
                            <TableCell>{project.name || project?.productName || project?.rfpProductName} {project?.barcode ? '' : "(Sub contract)"}</TableCell>
                            <TableCell>{project.recipeName || ''}</TableCell>
                            <TableCell>{project.jobcost_quantity}</TableCell>
                            {/* <TableCell>{fCurrency(project.jobcost_unit_cost)}</TableCell> */}
                            <TableCell>
                              {/* {fCurrency(project.jobcost_unit_cost * project.jobcost_quantity)} */}
                              {fCurrency(project.jobcost_total || project?.vendor_price * project?.jobcost_quantity || 0)}
                            </TableCell>
                          </TableRow>
                        ))}
                        {selectedProjects1?.filter(data=>(data.notFromRecipe != true && data.jobcost_quantity > 0))?.map((project, index) => (
                          <TableRow key={index}>
                            <TableCell>{project.name}</TableCell>
                            <TableCell>{''}</TableCell>
                            <TableCell>{project.jobcost_quantity}</TableCell>
                            {/* <TableCell>{fCurrency(project.jobcost_unit_cost)}</TableCell> */}
                            <TableCell>
                              {/* {fCurrency(project.jobcost_unit_cost * project.jobcost_quantity)} */}
                              {fCurrency(project.jobcost_total)}
                            </TableCell>
                          </TableRow>
                        ))}
                        {stockProducts?.filter(i => i.taken==1).map((product, index) => (
                        <TableRow key={index}>
                          <TableCell>{product.product_name}</TableCell>
                          <TableCell>{''}</TableCell>
                          <TableCell>{product.jobcost_quantity}</TableCell>
                          <TableCell>
                            {fCurrency((parseFloat(product.product_retail_price || 0)) * parseFloat(product.jobcost_quantity || 0))}
                          </TableCell>
                        </TableRow>
                      ))}
                        {/* {services?.filter(i => i.taken==1)?.map((service, index) => ( */}
                                                  {
                          //                         services
                          // ?.reduce((acc, curr) => {
                          //   if (curr.labour_cost_service_id === 10) {
                          //     if (!acc.some(item => item.labour_cost_service_id === 10)) {
                          //       const combined = { ...curr }
                          //       const sameItems = services.filter(s => s.labour_cost_service_id === 10)

                          //       combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0)
                          //       combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0)
                          //       combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2)
                          //       combined.taken = sameItems.some(s => s.taken === 1) ? 1 : 0;
                          //       acc.push(combined)
                          //     }
                          //   } else {
                          //     acc.push(curr)
                          //   }
                          //   return acc
                          // }, [])
                          // .filter(i => i.taken === 1)
                          // .map((service, index) => (
                            services
                        ?.reduce((acc, curr) => {
                          // ✅ Case 1: Consolidate install labour
                          if (curr.labour_cost_service_id === 10) {
                            const alreadyAdded = acc.some(item => item.labour_cost_service_id === 10);
                            if (!alreadyAdded) {
                              const sameItems = services.filter(s => s.labour_cost_service_id === 10);
                              const combined = { ...curr };

                              combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                              combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                              combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);
                              combined.taken = sameItems.some(s => s.taken === 1) ? 1 : 0;

                              acc.push(combined);
                            }
                          }

                          // ✅ Case 2: Consolidate all services with recipe_id (excluding labour)
                          else if (curr.recipe_id != null && curr.labour_cost_service_id !== 10) {
                            const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                            if (!alreadyAdded) {
                              const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                              if (recipeItems.length > 0) {
                                const combined = { ...recipeItems[0] };

                                combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0) + totalManualHours;
                                // Use actual jobcost_total_cost from services, not expected (qty * originalCost)
                                combined.jobcost_total_cost = (recipeItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0) + manuallyAddedPayoutsTotal).toFixed(2);
                                combined.taken = recipeItems.some(s => s.taken === 1) ? 1 : 0;
                                combined.__isRecipeGroup = true;

                                        acc.push(combined);
                                      }
                                    }
                                  }

                                  // ✅ Default case: push as-is
                                  else {
                                    acc.push(curr);
                                  }

                                  return acc;
                                }, [])
                        .filter(i => i.taken === 1 || (i.__isRecipeGroup && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0)))
                        .map((service, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ color: 'yellow' }}>{service.__isRecipeGroup ? 'Production Labor' : service.name}</TableCell>
                            <TableCell style={{ color: 'yellow' }}>{service.__isRecipeGroup ? '' : service.recipeName}</TableCell>
                            <TableCell style={{ color: 'yellow' }}>{parseFloat(service.jobcost_quantity || 0).toFixed(2)}</TableCell>
                            {/* <TableCell style={{ color: 'yellow' }}>{fCurrency(service.jobcost_unit_cost|| service.originalCost||service.unit_cost)}</TableCell> */}
                            <TableCell style={{ color: 'yellow' }}>
                              {projectData?.job_category_name=='Time & Material' ? 
                                <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_total_cost}</Typography>
                              : (service.labour_cost_service_id == 10 ?
                                <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_total_cost}</Typography>
                              :
                                <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_total_cost}</Typography>
                                // <Typography variant="subtitle2" style={{ color: 'yellow' }}>${((service.jobcost_quantity || service.qty)*(service.jobcost_unit_cost||service.originalCost||service.unit_cost))?.toFixed(2)}</Typography>
                              )}
                              {/* {fCurrency(((service.jobcost_quantity)*(service.jobcost_unit_cost||service.originalCost||service.unit_cost))?.toFixed(2))} */}
                            </TableCell>
                          </TableRow>
                        ))}
                        {/* Separate Production Labor row for Time & Material projects */}
                        {projectData?.job_category_name === 'Time & Material' && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0) && (
                          <TableRow key="production_labor_tm">
                            <TableCell style={{ color: 'yellow' }}>Production Labor</TableCell>
                            <TableCell style={{ color: 'yellow' }}></TableCell>
                            <TableCell style={{ color: 'yellow' }}>{parseFloat(totalManualHours || 0).toFixed(2)}</TableCell>
                            <TableCell style={{ color: 'yellow' }}>
                              <Typography variant="subtitle2" style={{ color: 'yellow' }}>
                                ${parseFloat(manuallyAddedPayoutsTotal || 0).toFixed(2)}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <Box>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* {projectData?.job_category_name === 'Time & Material' ? 
                      <Typography variant="h6">Material Cost</Typography>
                    : */}
                      {/* <Typography variant="h6">Additional Material Cost</Typography> */}
                      <Typography variant="h6">Material Cost</Typography>
                    {/* } */}
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">
                      {/* {fCurrency(materialPayOut1)} */}
                      {fCurrency((parseFloat(materialPayOut1 || 0) + parseFloat(materialTotal1 || 0) + parseFloat(totalStockCost1 || 0)).toFixed(2))}
                      </Typography>
                  </TableCell>
                </RowResultStyle>
                {/* {projectData?.job_category_name === 'Time & Material' ? "" : */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">Services Cost</Typography> */}
                    <Typography variant="h6">Additional Services</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(additionalLaborCost1)}</Typography>
                  </TableCell>
                </RowResultStyle>
                {/* } */}
                {/* {(projectData?.job_category_name === 'Time & Material') ? '' : */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    <Typography variant="h6">Production Labor</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(productFormulaCost1)}</Typography>
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                    <Typography variant="h6">Install Labor</Typography>

                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="h6">{fCurrency(installLaborCost1)}</Typography>
                  </TableCell>
                </RowResultStyle>
                {/* } */}
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    {/* <Typography variant="h6">{(projectData?.job_category_name === 'Time & Material') ? "Service Cost" : "Excess Labor Cost"}</Typography> */}
                    <Typography variant="h6">Excess Labor Cost</Typography>
                  </TableCell>
                  <TableCell align="left">
                    {/* <Typography variant="h6">{fCurrency(excessLaborCost1)}</Typography> */}
                    {/* {projectData?.job_category_name === 'Time & Material'? 
                    <Typography variant="h6">{fCurrency(additionalLaborCost1)}</Typography>
                    : */}
                    <Typography variant="h6">{fCurrency(excessLaborCost1)}</Typography>
                  {/* } */}
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell align="right" colSpan={4}>
                    <Typography variant="h6" sx={{ color: '#fc8c03' }}>Total Cost</Typography>
                  </TableCell>
                  <TableCell align="left">
                  {projectData?.job_category_name === 'Time & Material'? 
                    // <Typography variant="h6" sx={{ color: '#fc8c03' }}>{fCurrency(grandTotalCost2)}</Typography>
                    <Typography variant="h6" sx={{ color: '#fc8c03' }}>{fCurrency(grandTotalCost1)}</Typography>
                    :
                    <Typography variant="h6" sx={{ color: '#fc8c03' }}>{fCurrency(grandTotalCost1)}</Typography>
                  }
                  </TableCell>
                </RowResultStyle>
                </Box>
                </Box>
              </FormikProvider>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}


export const PrintableJobCostReport = forwardRef(({
  selectedProjects,
  selectedProjects1,
  services,
  materialPayOut,
  materialPayOut1,
  additionalLaborCost,
  additionalLaborCost1,
  productFormulaCost,
  productFormulaCost1,
  excessLaborCost,
  excessLaborCost1,
  grandTotalCost,
  grandTotalCost1,
  grandTotalCost2,
  projectData,
  data,
  installLaborCost,
  installLaborCost1,
  materialTotal1,
  materialTotal,
  totalStockCost1,
  totalStockCost,
  stockProducts,
  totalManualHours = 0,
  manualHoursCost = 0,
  manuallyAddedPayoutsTotal = 0
}, ref) => {
  const theme = useTheme();
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  return (
    <div ref={ref} style={{ padding: 24, fontFamily: 'Arial, sans-serif' }}>
      <Grid container spacing={3}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} sm={6}>
          <Box
            component="img"
            alt="logo"
            src={COMPANY_LOGO}
            id="logoImage"
            sx={{ height: 98 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ textAlign: 'right' }}>
          <Typography variant="h2">{COMPANY_NAME}</Typography>
        </Grid>
      </Grid>



        {/* <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Typography variant="h2">{COMPANY_NAME}</Typography>
          <Typography variant="h2">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="h3">
            {data?.address}<br /> {data?.city}<br /> {data?.state}, {data?.zipcode}
          </Typography>
          <Typography variant="h3">Telephone: +15208362947</Typography>
        </Grid> */}
      </Grid>
      {/* Expected Budget */}
      <Typography variant="h4" gutterBottom>Expected Budget</Typography>
      <Table size="small" style={{ marginBottom: 24 }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Product Formula</TableCell>
            <TableCell>Quantity / Hrs</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedProjects.map((item, i) => (
            <TableRow key={`expected-${i}`}>
              <TableCell>{item.name|| item?.productName || item?.rfpProductName} {item?.barcode ? '' : '(Sub contract)'}</TableCell>
              <TableCell>{item.recipeName || ''}</TableCell>
              <TableCell>{item.jobcost_actual_quantity}</TableCell>
              <TableCell>{fCurrency((item.jobcost_actual_unit_cost || item.unit_cost) * item.jobcost_actual_quantity)}</TableCell>
            </TableRow>
          ))}
          {selectedProjects1.filter(d => !d.notFromRecipe && d.jobcost_actual_quantity > 0).map((item, i) => (
            <TableRow key={`expected-extra-${i}`}>
              <TableCell>{item.name}</TableCell>
              <TableCell></TableCell>
              <TableCell>{item.jobcost_actual_quantity}</TableCell>
              <TableCell>{fCurrency(item.jobcost_actual_unit_cost * item.jobcost_actual_quantity)}</TableCell>
            </TableRow>
          ))}
          {stockProducts?.map((product, index) => (
            <TableRow key={index}>
              <TableCell>{product.product_name}</TableCell>
              <TableCell>{''}</TableCell>
              <TableCell>{product.location_quantity}</TableCell>
              <TableCell>
                {fCurrency((parseFloat(product.product_retail_price || 0)) * parseFloat(product.location_quantity || 0))}
              </TableCell>
            </TableRow>
          ))}
{/* {services.map((service, i) => ( */}
          {services?.reduce((acc, curr) => {
                                // ✅ Case 1: Consolidate install labour - untouched logic
                                if (curr.labour_cost_service_id === 10) {
                                  if (!acc.some(item => item.labour_cost_service_id === 10)) {
                                    const combined = { ...curr };
                                    const sameItems = services.filter(s => s.labour_cost_service_id === 10);

                                    combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                    combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                    combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);

                                    acc.push(combined);
                                  }
                                }

                                // Case 2: Consolidate ALL services that have any recipe_id (not null) but NOT labour
                                else if (curr.recipe_id != null) {
                                  const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                                  if (!alreadyAdded) {
                                    const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                    if (recipeItems.length > 0) {
                                      const combined = { ...recipeItems[0] };
                                      combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                      combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                      combined.jobcost_total_cost = recipeItems
                                      .reduce((sum, s) => sum + (Number(s.qty || 0) * Number(s.originalCost || s.unit_cost || 0)), 0)
                                      .toFixed(2);
                                      combined.__isRecipeGroup = true;
                                      acc.push(combined);
                                    }
                                  }
                                }
                                else {
                                  acc.push(curr);
                                }

                                return acc;
                              }, [])
                              .map((service, i) => (
            <TableRow key={`expected-service-${i}`}>
              <TableCell>{service.__isRecipeGroup ? 'Production Labor' : service.name}</TableCell>
              <TableCell>{service.__isRecipeGroup ? '' : service.recipeName}</TableCell>
              <TableCell>{parseFloat(service.qty || 0).toFixed(2)}</TableCell>
              <TableCell>
                {/* {fCurrency(service.qty * (service.originalCost || service.unit_cost))} */}
                 {service?.__isRecipeGroup
                  ? fCurrency(service.jobcost_total_cost)
                  : fCurrency((service.qty * (service.originalCost || service.unit_cost))?.toFixed(2))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box mb={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end',justifyContent: 'flex-end',textAlign: 'right', }}>
        {/* <Typography><strong>Additional Material Cost:</strong> {fCurrency(materialPayOut)}</Typography> */}
        {/* <Typography><strong>Material Cost:</strong> {fCurrency(materialTotal)}</Typography> */}
        <Typography>
          <strong>Material Cost:</strong>{' '}
          {fCurrency(parseFloat(materialTotal || 0) + parseFloat(totalStockCost || 0))}
        </Typography>
        <Typography><strong>Additional Services:</strong> {fCurrency(additionalLaborCost)}</Typography>
        <Typography><strong>Production Labor:</strong> {fCurrency(productFormulaCost)}</Typography>
        <Typography><strong>Install Labor:</strong> {fCurrency(installLaborCost)}</Typography>
        <Typography><strong>Excess Labor Cost:</strong> {fCurrency(excessLaborCost)}</Typography>
        <Typography><strong>Total Cost:</strong> {fCurrency(grandTotalCost)}</Typography>
      </Box>

      {/* Actual Budget */}
      <Typography variant="h4" gutterBottom>Actual Budget</Typography>
      <Table size="small" style={{ marginBottom: 24 }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Product Formula</TableCell>
            <TableCell>Quantity / Hrs</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedProjects.filter(p => p.taken === 1).map((item, i) => (
            <TableRow key={`actual-${i}`}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.recipeName || ''}</TableCell>
              <TableCell>{item.jobcost_quantity}</TableCell>
              <TableCell>{fCurrency(item.jobcost_total)}</TableCell>
            </TableRow>
          ))}
          {selectedProjects1.filter(d => !d.notFromRecipe && d.jobcost_quantity > 0).map((item, i) => (
            <TableRow key={`actual-extra-${i}`}>
              <TableCell>{item.name}</TableCell>
              <TableCell></TableCell>
              <TableCell>{item.jobcost_quantity}</TableCell>
              <TableCell>{fCurrency(item.jobcost_total)}</TableCell>
            </TableRow>
          ))}
          {stockProducts?.filter(i => i.taken==1).map((product, index) => (
            <TableRow key={index}>
              <TableCell>{product.product_name}</TableCell>
              <TableCell>{''}</TableCell>
              <TableCell>{product.jobcost_quantity}</TableCell>
              <TableCell>
                {fCurrency((parseFloat(product.product_retail_price || 0)) * parseFloat(product.jobcost_quantity || 0))}
              </TableCell>
            </TableRow>
          ))}
          {/* {services.filter(s => s.taken === 1).map((service, i) => ( */}
          {
            services
              ?.reduce((acc, curr) => {
                // ✅ Case 1: Consolidate install labour
                if (curr.labour_cost_service_id === 10) {
                  const alreadyAdded = acc.some(item => item.labour_cost_service_id === 10);
                  if (!alreadyAdded) {
                    const sameItems = services.filter(s => s.labour_cost_service_id === 10);
                    const combined = { ...curr };

                    combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                    combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                    combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);
                    combined.taken = sameItems.some(s => s.taken === 1) ? 1 : 0;

                    acc.push(combined);
                  }
                }

                // ✅ Case 2: Consolidate all services with recipe_id (excluding labour)
                else if (curr.recipe_id != null && curr.labour_cost_service_id !== 10) {
                  const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                  if (!alreadyAdded) {
                    const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                    if (recipeItems.length > 0) {
                      const combined = { ...recipeItems[0] };

                      combined.qty = recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                      combined.jobcost_quantity = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0) + totalManualHours;
                      // Use actual jobcost_total_cost from services, not expected (qty * originalCost)
                      combined.jobcost_total_cost = (recipeItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0) + manuallyAddedPayoutsTotal).toFixed(2);
                      combined.taken = recipeItems.some(s => s.taken === 1) ? 1 : 0;
                      combined.__isRecipeGroup = true;

                              acc.push(combined);
                            }
                          }
                        }

                        // ✅ Default case: push as-is
                        else {
                          acc.push(curr);
                        }

                        return acc;
                      }, [])
              .filter(i => i.taken === 1 || (i.__isRecipeGroup && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0)))
              .map((service, i) => (
            <TableRow key={`actual-service-${i}`}>
              <TableCell>{service.__isRecipeGroup ? 'Production Labor' : service.name}</TableCell>
              <TableCell>{service.__isRecipeGroup ? '' : service.recipeName}</TableCell>
              <TableCell>{parseFloat(service.jobcost_quantity || 0).toFixed(2)}</TableCell>
              <TableCell>
                {fCurrency(service.jobcost_total_cost)}
              </TableCell>
            </TableRow>
          ))}
          {/* Separate Production Labor row for Time & Material projects in PDF */}
          {projectData?.job_category_name === 'Time & Material' && (totalManualHours > 0 || manuallyAddedPayoutsTotal > 0) && (
            <TableRow key="actual-production-labor-tm">
              <TableCell>Production Labor</TableCell>
              <TableCell></TableCell>
              <TableCell>{parseFloat(totalManualHours || 0).toFixed(2)}</TableCell>
              <TableCell>{fCurrency(manuallyAddedPayoutsTotal)}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end',textAlign: 'right', }}>
        <Typography><strong>Material Cost:</strong>
         {/* {fCurrency(materialPayOut1)} */}
         {fCurrency((parseFloat(materialPayOut1 || 0) + parseFloat(materialTotal1 || 0) + parseFloat(totalStockCost1 || 0)).toFixed(2))}
         </Typography>
        <Typography><strong>Additional Services:</strong> {fCurrency(additionalLaborCost1)}</Typography>
        <Typography><strong>Production Labor:</strong> {fCurrency(productFormulaCost1)}</Typography>
        <Typography><strong>Install Labor:</strong> {fCurrency(installLaborCost1)}</Typography>
        <Typography><strong>Excess Labor Cost:</strong> {fCurrency(excessLaborCost1)}</Typography>
        <Typography ><strong>Total Cost:</strong> {
          fCurrency(projectData?.job_category_name === 'Time & Material' ? grandTotalCost1 : grandTotalCost1)
        }</Typography>
      </Box>
    </div>
  );
});

